export const SERVICE_ROUTE_UPLOAD: string = process.env.VUE_APP_SERVICE_ROUTE_BACKEND || '/api';

export const APM_ENABLED: boolean = process.env.VUE_APP_APM_ENABLED === undefined ? true : process.env.VUE_APP_APM_ENABLED === 'true';

export const DOPPLER_ENVIRONMENT: string = process.env.VUE_APP_DOPPLER_ENVIRONMENT || 'SNAPSHOT';


